import React, { Component } from "react";
import AntdTimePicker, { TimePickerProps } from "antd/lib/time-picker";
import PagePoint from "../page-point/pagePointEnhanced";
import { ConfigConsumer, ConfigConsumerEProps } from "../config-provider";
import "antd/lib/time-picker/style";

interface TPProps extends TimePickerProps {
  forwardedRef?: any;
}
class TimePicker extends Component<TPProps> {
  render() {
    const { forwardedRef, ...rest } = this.props;
    AntdTimePicker.prototype['componentName'] = "TimePicker";
    return (
      <ConfigConsumer>
        {({ pagePoint }: ConfigConsumerEProps) =>
          pagePoint ? (
            <PagePoint
              compType="TimePicker"
              {...this.props}
              render={eventprops => (
                <AntdTimePicker ref={forwardedRef} {...rest} {...eventprops} />
              )}
            ></PagePoint>
          ) : (
            <AntdTimePicker ref={forwardedRef} {...rest} />
          )
        }
      </ConfigConsumer>
    );
  }
}

export default React.forwardRef((props: TPProps, ref) => {
  return <TimePicker {...props} forwardedRef={ref} />;
});



// WEBPACK FOOTER //
// ./src/components/time-picker/index.tsx